<template>
	<div class="inputBox">
		<div class="inputBox-content" :class="{allInput_content:!props.showPrepend}">
			<w-input class="input" @keydown="setInputEnter($event)" v-if="from!='add'" :placeholder="getplaceHolder"  v-model="keyWords" clearable autocomplete="off">
				<template #prepend v-if="props.showPrepend">
					<div class="originBox" @click.stop="originBoxClick">
						<span>{{originType=='1'?t('chat.search.webAll'):t('chat.search.origin') }}</span>
						<span v-if="originType=='2'" class="number-box">
						<span class="number" :class="{ longNum: num>= 10 }" v-if="props.from=='add'">{{ num }}</span>
						<span class="number" :class="{ longNum: editOriginNum >= 10 }" v-if="props.from=='edit'">{{ editOriginNum }}</span>
						</span>
						<SvgIcon class="icon" :name="!isCollapse ? 'cool-ArrowUpSLineWe' : 'cool-ArrowDownSLineWe'" size="16" color="#646479" />
					</div>
				</template>
				<template #suffix>
					<div class="sendBtn">
						<div class="tipsbox" v-if="infoMessage&&popVisible">
							{{infoMessage}}
							<!-- <div class="arrow"></div> -->
						</div>
						<w-button
							type="primary"
							:disabled="getDisabled"
							class="sendBox"
							@mouseover="showTips" @mouseout="hideTips"
							:class="{ sendBtnVip: storesUserInfo.userInfos.vipType == '1', cansend: !getDisabled }"
							@click="send"
						>
							<template #icon>
								<!-- <img @dragstart="preventImageDrag" :src="sendIcon" alt="" /> -->
								<CoolSousuo  size="16" color="#fff"/>
							</template>
						</w-button>
					</div>
				</template>
			</w-input>
			<div class="home-textArea" v-else>
				<w-textarea :placeholder="getplaceHolder" v-model="keyWords" :auto-size="{minRows:3,maxRows:3 }" @keydown="setInputEnter($event)"></w-textarea>
				<div class="bottom-btn">
					<div class="left-origin" @click.stop="originBoxClick">
						<span>{{originType=='1'?t('chat.search.webAll'):t('chat.search.origin') }}</span>
						<span v-if="originType=='2'" class="number-box">
						<span class="number" :class="{ longNum: num>= 10 }" v-if="props.from=='add'">{{ num }}</span>
						<span class="number" :class="{ longNum: editOriginNum >= 10 }" v-if="props.from=='edit'">{{ editOriginNum }}</span>
						</span>
						<SvgIcon class="icon" :name="!isCollapse ? 'cool-ArrowUpSLineWe' : 'cool-ArrowDownSLineWe'" size="16" color="#646479" />
					</div>
					<div class="right-btn">				
						<w-button
							type="primary"
							:disabled="getDisabled"
							class="sendBox"
							@mouseover="showTips" @mouseout="hideTips"
							:class="{ sendBtnVip: storesUserInfo.userInfos.vipType == '1', cansend: !getDisabled }"
							@click="send"
						>
							<template #icon>
								<CoolSousuo  size="16" color="#fff"/>
							</template>
						</w-button>
						<div class="right-tips" v-if="infoMessage&&popVisible">
							{{infoMessage}}
						</div>
					</div>
				</div>
			</div>
			<div class="originContentBox" v-if="isCollapse" :class="{ isOriginSelect: originType=='2' }">
				<div class="tabs">
					<w-tabs type="rounded" :active-key ="originType" @tab-click="changeModel">
						<w-tab-pane v-for="item in webSelect" :key="item.id"  :title="item.name" :value="item.id"></w-tab-pane>
					</w-tabs>
				</div>
				<div class="webAllInfo" v-if="originType=='1'">{{ t('chat.search.webAllInfo') }}</div>
				<div class="originContentBox-head" v-if="originType=='2'">
					<div class="head-left">
						<div class="head-left-item" v-for="(item, index) in headList" :key="index" @click="changeTab(item)">
							<div class="item-name" :class="{ active: item.id == currentTab }">
								<span class="name">{{ item.name }}</span>
							
								<!-- <span class="name">{{ item.name }}</span>
								<span :class="{ activeNum: item.id == currentTab }" v-if="getWebNum>0&&item.id==1">{{ getWebNum }}</span>
								<span :class="{ activeNum: item.id == currentTab }" v-if="getKnowNum>0&&item.id!=1">{{getKnowNum }}</span> -->
							</div>
						</div>
					</div>
					<!--先隐藏 -->
					<!-- <div class="head-right" v-if="currentTab == 1&&originType=='2'">
						<w-popover position="br" @popup-visible-change="changePop" :show-arrow="false" trigger="hover" content-class="select-dropdown">
							<div class="icon-box" :class="{ active: isSlect||clickFlag }">
								<CoolShaixuan  size="18" :color="isSlect||clickFlag?'#355EFF':'#727298'" class="icon" @mouseenter="isSlect=true" @mouseleave="isSlect=false"/>
							</div>
							
							<template #content>
								<div class="title">	{{ t('chat.search.webOrigin') }}</div>
								<div class="lists">
									<div
										class="item"
										v-for="item in typeList"
										:key="item.id"
										:value="item.id"
										:class="{ active: item.select }"
										@click.stop="clickType(item)"
									>
										{{ $t(item.name) }}
									</div>
								</div>
							</template>
						</w-popover>
					</div> -->
				</div>
				<div class="originContentBox-content" @scroll="handleScroll" v-if="originType=='2'">
					<div v-if="currentTab == 1" class="origin-list">
						<div class="origin-list-box">
							<div class="origin-list-item" v-for="(item, index) in originLists" :key="index" @click.stop="selectOrigin(item)">
								<div class="item-left">
									<img :src="item.icon" alt="" />
								</div>
								<div class="item-right">
									<div class="item-right-name">{{ item.name }}</div>
									<div class="item-right-label">
										<img :src="label" alt="" />
										<div class="type">{{ item.categoryName }}</div>
										<div class="line"></div>
										<div class="desc">{{ item.description }}</div>
									</div>
								</div>
								<img :src="isselect" alt="" class="selected" v-if="item.isSelect == 'true'" />
								<img :src="noSelect" alt="" class="noselect" v-else />
								<div class="recommend" v-if="item.isRecommend==1">
									<CoolDianzanxuanzhong  size="12" color="#FF6200"/>
									<span class="name">{{ t('chat.search.recommend') }}</span>
								</div>
							</div>
						</div>
					</div>
					<div v-if="currentTab == 2" class="knowledgeModelCard-list">
						<div class="knowledgeModelCard-list-box" v-if="knowledgeList.length">
							<div v-for="(item, index) in knowledgeList" :key="index" class="data-item" @click.stop="selectKnowledge(item)">
								<div class="item-icon" v-if="item.icon" :style="{ backgroundColor: bgColor[item.icon] }">
									<div class="icon-content">{{ item.icon }}</div>
								</div>
								<div class="item-icon" v-else :style="{ backgroundColor: item.avatarColor }">
									<img class="icon-content" :src="getIcon(item.avatar)" />
								</div>
								<div class="item-desc">
									<w-tooltip :popup-visible="item.showTips" :content="item.name" placement="top">
									<div class="desc-name"  @mouseenter="mouseEnterHandler($event,item)" @mouseleave="item.showTips=false">{{ item.name }}</div>
									</w-tooltip>
									<div class="desc-num">{{ item.fileCount }}{{ $t('chat.addRole.selectedName') }}</div>
								</div>
								<img :src="isselect" alt="" class="selected" v-if="item.isSelect == true" />
								<img :src="noSelect" alt="" class="noselect" v-else />
							</div>
						</div>
						<div v-else-if="getResult && !knowledgeList.length" class="nodata-box">
							<w-empty>
								<template #image>
									<img class="nodata" :src="noDataImg" alt="" />
								</template>
								<div class="info-title">{{ $t('chat.center.noKnowList') }}</div>
							</w-empty>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts" setup>
import { ref, onMounted, computed, defineExpose, watch,onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserInfo } from '/@/stores/userInfo';
import { useI18n } from 'vue-i18n';
import { debounce, cloneDeep } from 'lodash-es';
import { pageQuery } from '/@/api/chat';
import noDataImg from '/@common/assets/chat/nodataconv.svg';
import sendIcon from '/@common/assets/chat/sendIcon.svg';
import {
	saveOrUpdateUserUserKnowledgeBase,
	searchEngineCategory,
	getSearchEngineByCategoryIds,
	saveOrUpdateUserSearchEngine,
	getUserKnowledgeBaseListPageQuery,
	getUserSearchEngineAndUserKnowledgeBase,
	saveOrUpdateUserSearchEngineType
} from '/@/api/chat';
import search from '/@common/assets/chat/search.svg';
import label from '/@common/assets/chat/label.svg';
import noSelect from '/@common/assets/chat/noSelect.svg';
import isselect from '/@common/assets/chat/isselect.svg';
import { Message } from 'winbox-ui-next';
import { useChatStore } from '/@/stores/chat';
import mittBus from '/@common/utils/mitt';
interface Props {
	question: string;
	placeHolder?:string
	from?:string;
	showPrepend:boolean;//true:有来源 false没有
	searchEngineList?:Array<any>;
	searchEngineType?:number,
	groupId?:string;
	regens?: [];
	index?:number
}
const chatStore = useChatStore();
const props = defineProps<Props>();
const popVisible=ref(false)
const infoMessage=ref('')
const originType=ref('1')
const storesUserInfo = useUserInfo();
const { t } = useI18n();
const keyWords = ref('');
const isCollapse = ref(false);
const currentTab = ref(1);
const originLists = ref([]);
const webNum = ref(0);
const knowNum = ref(0);
const isSlect=ref(false)
const clickFlag=ref(false)
const headList = ref([
	{
		// name: t('chat.search.web'),
		name: t('chat.search.webInfo'),
		id: 1,
		num: 0,
	},
	// {
	// 	name: t('chat.search.file'),
	// 	id: 2,
	// 	num: 0,
	// },
]);
const webSelect= ref([
	{
		name: t('chat.search.webAll'),
		id: 1,
	},
	{
		name: t('chat.search.originSelect'),
		id: 2
	},
]);
const bgColor = ref({
	'💻': 'rgba(53,94,255,0.06)',
	'📝': 'rgba(255, 98, 0, 0.06)',
	'🧩': 'rgba(102, 0, 255, 0.06)',
	'📍': 'rgba(245, 75, 91, 0.06)',
	'🌠': 'rgba(245, 75, 91, 0.06)',
	'📖': 'rgba(53, 94, 255, 0.06)',
	'📊': 'rgba(53,94,255,0.06)',
	'⚖️': 'rgba(53,94,255,0.06)',
	'🔖': 'rgba(53,94,255,0.06)',
	'🗓': 'rgba(53,94,255,0.06)',
});

const placeHolderMap = ref({
	add: t('chat.center.aiSearchPlace'),
	edit: t('chat.center.aiSearchPlace'),
})
const getIcon=(icon:any)=>{
	return new URL(`../../../../../common/assets/chat/icon/${icon}.svg`, import.meta.url).href;
}
watch(()=>keyWords.value,(newVal)=>{
	if(newVal){
	   let urlRegex = /(https?:\/\/[^\s]+)/g
	   let yayiUrl=/<yayi-url[^>]*>/g
	   if(newVal&&newVal.match(urlRegex)){
		   Message.info( t('common.tips.infoMessage'))
		   keyWords.value="";
		   return
		}
		if(newVal&&newVal.match(yayiUrl)){
			Message.info( t('common.tips.infoMessage2'))
			keyWords.value="";
		}
	}
})
const getDisabled=computed(()=>{//发送状态
	//针对追问的特殊处理下
	if(props.from=='probe'){
		infoMessage.value=''
		if(keyWords.value||props.placeHolder){
			return false
		}else{
			return true
		}
	}else{
		if(originType.value==1){
			infoMessage.value=!keyWords.value?t('chat.search.sendTitle'):''
			return !keyWords.value
		}else{
			if(props.from=='add'){
				if(keyWords.value&&num.value){
					infoMessage.value=''
				}else{
					if(!num.value){
						infoMessage.value=t('chat.search.originInfo')
					}else{
						infoMessage.value=keyWords.value?'':t('chat.search.sendTitle')
					}
				}
				return keyWords.value&&num.value?false:true
			}else{
				if(keyWords.value&&editOriginNum.value){
					infoMessage.value=''
				}else{
					if(!editOriginNum.value){
						infoMessage.value=t('chat.search.originInfo')
					}else{
						infoMessage.value=keyWords.value?'':t('chat.search.sendTitle')
					}
				}
				return keyWords.value&&editOriginNum.value?false:true
			}
		}
	}
	let message=t('chat.search.sendTitle')
	if(keyWords.value||props.placeHolder){
		message=''
	}
})
const changeModel=async(val:string)=>{
	if(val=='1'){
		let data={
			searchEngineType:0,
		}
		let res=await saveOrUpdateUserSearchEngineType(data)
		if(res.code==200){
			originType.value=val
		}else{
			Message.error(res.msg)
		}
	}else{
		getOriginList('tab')
		originType.value=val
	}

}
const mouseEnterHandler=(e:Event,item:object)=>{
	let target = e.target as HTMLElement;
  let textLength = target.clientWidth;
  let containerLength = target.scrollWidth;
  if (textLength < containerLength) {
    item.showTips = true;
  } else {
    item.showTips = false;
  }
}
const getplaceHolder = computed(() => { 
	if (props.placeHolder) {
		return props.placeHolder
	} else if (props.from) {
		return placeHolderMap.value[props.from] || t('chat.center.searchPlace')
	} else {
		return ''
	}
})

const getKeyword = computed(() => {
	if (keyWords.value) {
		return keyWords.value
	}else if (props.placeHolder) {
		return props.placeHolder
	} else {
		return ''
	}
})
const selectIds = ref([]);
const editSelectIds = ref([]);
const knowledgeBases = ref([]);
const knowledgeList = ref([]);
const current = ref(1);
const pageSize = ref(1);
const name = ref('');
const num = ref(0);
const getResult = ref(false);
const typeList = ref([]);
const categoryIds = ref(['0']);
const getWebNum = ref(0);
const getKnowNum = ref(0);
const emit = defineEmits();
const editOriginNum=ref(0)
watch(
	() => props.question,
	(newVal) => {
		if (newVal) {
			keyWords.value = newVal;
		}
	},{
		immediate: true,
	}
);
watch(()=>props?.searchEngineList,(newVal)=>{
	try {
		editOriginNum.value = newVal.length
	} catch (err) { }
},{deep:true,immediate:true})
const setInputEnter = async (e) => {
	if (13 === e.keyCode) {
		e.stopPropagation();
		e.preventDefault();
		if(!getKeyword.value){
			Message.info({
			id: 'inputInfo',
			content: t('chat.search.info'),
			duration: 1000,
		});
			return
		}
		send();
	}
};
const send = () => {
	// localStorage.setItem('showInfoCard','false')
	// chatStore.isShowLogInfo=false
	chatStore.setUserLogStatus()
	let data={
		text:getKeyword.value.trim(),
		searchEngineIdList:getSelectLists(),
		searchEngineType:getOriginType(),
		regens:props.regens
	}
	if(props.from=='edit'){
		data.groupId=props.groupId
	}
	data.index=props.index
	emit('sendQuestion', data);
	keyWords.value = '';
};
const preventImageDrag = (event) => {
	event.preventDefault(); // 阻止默认行为
};
const originBoxClick = () => {
	emit('changeRecommend', isCollapse.value);
	isCollapse.value = !isCollapse.value;
	currentTab.value = 1;
	if(props.from==='add'){
		getOriginList();
	}
	
};
const showTips=()=>{
	popVisible.value=true
}
const hideTips=()=>{
	popVisible.value=false
}
const clickType = (item: object) => {
	//多选先隐藏
	// let find = typeList.value.filter((itm: any) => {
	// 	return itm.select;
	// });
	// if(item.id!=0){
	// 	let findAll= typeList.value.filter((itm: any) => {
	// 	return itm.id==0;
	// });
	// if(findAll.length&&!item.select){
	// 	findAll[0].select=false
	// }
	// }else{
	// 	typeList.value.forEach(item=>{
	// 		if(item.id!=0){
	// 			item.select=false
	// 		}
	// 	})
	// }
	// if (find.length <= 1 && item.select) {
	// 	Message.info({
	// 		id: 'selectInfo',
	// 		content: t('chat.search.select'),
	// 		duration: 1000,
	// 	});
	// 	return;
	// }
	//单选
	typeList.value.forEach(itm=>{
		itm.select=false
	})
	item.select = !item.select;
	categoryIds.value = [];
		typeList.value.forEach((item: any) => {
			if (item.select) {
				categoryIds.value.push(item.id);
			}
		});
		getOriginList();

};
const changePop = (val) => {
	clickFlag.value=val
	if (!val && typeList.value.length) {
		// categoryIds.value = [];
		// typeList.value.forEach((item: any) => {
		// 	if (item.select) {
		// 		categoryIds.value.push(item.id);
		// 	}
		// });
		// getOriginList();
	} else {
		typeList.value.forEach((item: any) => {
			if (categoryIds.value.includes(item.id)) {
				item.select = true;
			} else {
				item.select = false;
			}
		});
	}
};
const addSelectOrigin=async(item:object)=>{
	// if(getWebNum.value==1&&item.isSelect=='true'){
	// 	Message.info({
	// 		id: 'selectOriginInfo',
	// 		content: t('chat.search.selectInfo'),
	// 		duration: 1000,
	// 	});
	// 	return;
	// }
	item.isSelect = item.isSelect == 'true' ? 'false' : 'true';
	let data = {
		isSelect: item.isSelect,
		searchEngineId: item.id,
	};
	await saveOrUpdateUserSearchEngine(data);
	getNum();
}
const getSelectLists=()=>{
	if(originType.value=='1'&&props.from!='probe'){
		return []
	}
	let ids=[]
	if(props.from!='probe'){
		originLists.value.forEach(item=>{
		if(item.isSelect=='true'){
     ids.push(item.id)
		}
	})
	}else{
		props?.searchEngineList.forEach(item=>{
			ids.push(item.id)
		})
	}

  return ids
}
const editSelectOrigin=async(item:object)=>{
	// let find=originLists.value.filter(itm=>itm.isSelect=='true')
	// if(find.length==1&&item.isSelect=='true'){
	// 	Message.info({
	// 		id: 'selectOriginInfo',
	// 		content: t('chat.search.selectInfo'),
	// 		duration: 1000,
	// 	});
	// 	return;
	// }
	if(item.isSelect=='true'){
		editOriginNum.value-=1
	}else{
		editOriginNum.value+=1
	}
	item.isSelect = item.isSelect == 'true' ? 'false' : 'true';

}
const selectOrigin = async (item: object) => {
	//编辑选择下逻辑在前端
	props.from=='add'?addSelectOrigin(item):editSelectOrigin(item)
};
const clearListType = () => {
	selectIds.value = [];
	knowledgeBases.value = [];
	name.value = '';
	current.value = 1;
	knowledgeList.value = [];
	originLists.value = [];
};
const changeTab = (item: object) => {
	//先return 知识库效果不好
	return;
	currentTab.value = item.id;
	if (item.id == 2) {
		refreshList();
	} else {
		// categoryIds.value = ['0'];
		getOriginList();
	}
};
const refreshList = () => {
	clearListType();
	searchChange();
};
const selectKnowledge = async (item: object) => {
	item.isSelect = !item.isSelect;
	let data = {
		isSelect: item.isSelect,
		knowledgeBaseAuthority: item.authority,
		knowledgeBaseCharCount: item.charCount,
		knowledgeBaseDescr: item.descr,
		knowledgeBaseFileCount: item.fileCount,
		knowledgeBaseIcon: item.icon,
		knowledgeBaseId: item.id,
		knowledgeBaseName: item.name,
		robotId: item.robotId,
	};
	await saveOrUpdateUserUserKnowledgeBase(data);
	getNum();
};
const handleScroll = debounce(() => {
	if(currentTab.value==1){
		return
	}
	//滚动分页
	if (pageSize.value / 20 > current.value) {
		current.value += 1;
		searchChange();
	}
}, 300);
const searchChange = async (type?: string) => {
	//调用查询接口
	getResult.value = false;
	let data = {
		current: current.value,
		size: 20,
		name: name.value,
	};
	let res = await getUserKnowledgeBaseListPageQuery(data);
	getResult.value = true;
	if (res?.code == 200) {
		pageSize.value = res.data.total;
		if (res.data?.records) {
			let currentData=cloneDeep(res.data.records)
			knowledgeList.value = [...knowledgeList.value,...currentData];
		}
	}
};
const getSearchEngineCategory = async () => {
	typeList.value = [];
	let res = await searchEngineCategory();
	if (res.code == 200) {
		res.data.forEach((element) => {
			if (categoryIds.value.includes(element.id)) {
				element.select = true;
			} else {
				element.select = false;
			}
		});
		typeList.value = res.data;
	}
};
const getOriginList = async (type?: string) => {
	let params = {
		categoryIds: categoryIds.value.join(),
	};
	let res = await getSearchEngineByCategoryIds(params);
	if (res.code == 200) {
		if(props.searchEngineList&&props.searchEngineList.length&&props.from=='edit'){
			res.data.forEach((item)=>{
				item.isSelect='false'
				props.searchEngineList.forEach(i=>{
					if(i.id==item.id){
						item.isSelect='true'
					}
				})
			})
		}
		originLists.value = res.data;
		// 有个紧急任务，需要录给中国搜索的demo
		// originLists.value.push({
		// 	"id": "191",
		// 	"name": "中国搜索",
		// 	"description": "国家权威搜索引擎",
		// 	"icon": "https://n10.cmsfile.pg0.cn/group2/M00/15/DD/CgoOEWQn1KSAFYNpAABMKL8QMJ8457.png",
		// 	"code": "bilibili",
		// 	"isRecommend": 0,
		// 	"categoryName": "新闻",
		// 	"categoryCode": "video",
		// 	"categoryId": "11",
		// 	"isSelect": "false"
		// })
		if(type){
			let find = res.data.filter((item) => {
			return item.isSelect == 'true';
		});
		num.value=find.length
		if(props.from=='edit'){
			editOriginNum.value=find.length
		}
		}
		// let find = res.data.filter((item) => {
		// 	return item.isSelect == true;
		// });
	}
};
const getNum = async () => {
	let res = await getUserSearchEngineAndUserKnowledgeBase();
	if (res.code == 200) {
		originType.value=res.data?.searchEngineType==0?'1':'2'
		if(res.data?.searchEngineType==1){
			getOriginList();
		}
		if (res.data?.userKnowledgeBaseList || res.data?.userSearchEngineList){
			num.value = res.data.userKnowledgeBaseList.length + res.data.userSearchEngineList.length;
		    getWebNum.value = res.data.userSearchEngineList.length;
		    getKnowNum.value = res.data.userKnowledgeBaseList.length;
		}
		
	}
};
const clickParent=(e:Event)=>{
  // 获取目标元素
  const targetElement = document.querySelector('.originContentBox') as HTMLDivElement;
  const OtherBox=document.querySelector('.input_box') as HTMLDivElement;
  if(OtherBox?.contains(e.target as Node)){
	return
  }
  if(!targetElement?.contains(e.target as Node)&&isCollapse.value){
	emit('changeRecommend',true);
	isCollapse.value =false;
	currentTab.value = 1;
  }
 }
 const getOriginSelectLists=()=>{
	if(originType.value=='1'){
		return []
	}
	let ids=[]
	originLists.value.forEach(item=>{
		if(item.isSelect=='true'){
     ids.push(item.id)
		}
	})
  return ids
}
const getOriginType=()=>{
	if(props.from!='probe'){
	 return	originType.value=='1'?0:1
	}else{
		return props?.searchEngineType
	}
}
onMounted(() => {
	getSearchEngineCategory();
	if(props.from!='edit'){
		getNum();
	}else{
		originType.value=props.searchEngineType==0?'1':'2'
		getOriginList('tab');
	}
	
	document.addEventListener('click',clickParent)
});
onUnmounted(()=>{
	document.removeEventListener('click',clickParent)
})
defineExpose({
	isCollapse,
	getOriginSelectLists,
	getOriginType
});
</script>
<style lang="scss" scoped>
@mixin text() {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.inputBox {
	width:100%;
	margin: 0 auto;
	position: relative;

	.inputBox-content {
		width: 100%;
		border-radius: 16px;
		box-shadow: 0px 6px 20px 0px rgba(30, 64, 175, 0.06);
		// border: 1px solid #e4e8ee;
		box-sizing: content-box;
	}
	.input{
		height: 60px;
	}
	.home-textArea{
		  box-shadow: 0px 6px 20px 0px rgba(30,64,175,0.06);
          border-radius: 16px;
		  background: #FFFFFF;
		  position: relative;
		//   z-index: 3;
		  &::after{
			content: '';
            width: calc(100% + 2px);
            height:  calc(100% + 2px);
            position: absolute;
            border-radius: 16px;
			background: var(--aisearch-border-color);
            top: -1px;
            left: -1px;
            z-index: -1;
		  }
		:deep(.w-textarea-wrapper){
			border: none;	
			border-radius: 16px;
			padding: 16px 0px 0px;
		}
		.bottom-btn{
			display: flex;
			justify-content: space-between;
			padding: 0 16px 16px;
			.left-origin{
				cursor: pointer;
		        display: flex; 
		        align-items: center; 
		        font-size: var(--font14);
				color: #646479;
				justify-content: center;
				padding-left: 5px;
				&:hover{
					background: var(--active-bg-menu);
					border-radius: 6px;
				}
				
				
		        .icon {
		        	margin: 0 5px 0 7px;
		        }
		        .number {
		        	width:20px;
		        	height:20px;
		        	text-align: center;
		        	display: flex; 
                    justify-content: center;
					align-items: center;
		        	background: #f4f6f9;
		        	margin-left: 3px;
		        	border-radius: 50%;
		        	overflow: hidden;
		        }
		        .longNum{
		        	width:25px;
		        	height:25px;
		        }

			}
			.right-btn{
				position: relative;
				.w-btn{
				display: flex;
				align-items: center;
				justify-content: center;
				width: 44px;
                height: 32px;
                border-radius: 16px;
				}
				.right-tips{
					position: absolute;
					min-width: 135px;
				    display: flex;
				    align-items: center;
				    bottom: 40px;
				    right: 0px;
				    transform: translateX(calc(50% - 20px));
				    height: 30px;
				    background: #646479;
				    font-size: var(--font14);
				    padding: 4px 10px;
				    border-radius: 6px;
				    color: #ffffff;
				    .arrow {
					   position: absolute;
					   z-index: -1;
					   bottom: -4px;
					   left: calc(50% - 4px);
					   display: block;
					   box-sizing: border-box;
					   width: 8px;
					   height: 8px;
					   background-color: #646479;
					   content: '';
					   transform: rotate(45deg);
					}	
				}
			}
		}

	}
	
	.originBox {
		cursor: pointer;
		display: flex; 
		align-items: center; 
		font-size: var(--font16);
		.icon {
			margin: 0 12px 0 7px;
		}
		.number-box{
			
		}
		.number {
			width:20px;
			height:20px;
			text-align: center;
			display: flex; 
      justify-content: center;
      align-items: center; 
			background: #f4f6f9;
			margin-left: 3px;
			border-radius: 50%;
			overflow: hidden;
		}
		.longNum{
			width:25px;
			height:25px;
		}
	}
	.input {
		height: 60px;
		width: 100%;
		.sendBtn {
			position: relative;
			.tipsbox {
				position: absolute;
				display: flex;
				align-items: center;
				bottom: 50px;
				right: 0px;
				transform: translateX(calc(50% - 20px));
				height: 30px;
				background: #646479;
				font-size: var(--font14);
				padding: 4px 10px;
				border-radius: 6px;
				color: #ffffff;
				.arrow {
					position: absolute;
					z-index: -1;
					bottom: -4px;
					left: calc(50% - 4px);
					display: block;
					box-sizing: border-box;
					width: 8px;
					height: 8px;
					background-color: #646479;
					content: '';
					transform: rotate(45deg);
				}
			}
		}
		.sendBox {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 36px;
			height: 36px;
			background: rgba(53, 94, 255, 0.4);
			border-radius: 22px;
		}
		.cansend {
			background: #355eff;
		}
	}
	:deep(.w-input-prepend) {
		border-color: transparent;
		border-radius: 16px 0 0 16px;
		padding: 16px 16px 16px 24px;
		padding-right: 0px !important;
		color: #646479;
		font-size: var(--font16);
		&:after {
			content: '';
			width: 1px;
			height: 30px;
			background: #e4e8ee;
		}
	}
	:deep(.w-input-append) {
		border-color: transparent;
	}
	:deep(.w-input) {
		padding-right: 13px;
		&::placeholder {
			font-size: var(--font16) !important;
			color: #9a99aa;
		}
	}
	:deep(.w-input-wrapper) {
		border-color: transparent;
		border-radius: 0 16px 16px 0;
		border-left: 0;
		border:0 !important;
	}
}
.allInput_content{
	:deep(.w-input-wrapper) {
		border-radius:16px;
	}
	}
.originContentBox {
	width: 100%;
	background: #ffffff;
	border-radius: 16px;
	background-color: #fff;
	margin-top: 8px;
	padding: 24px;
	position:absolute;
	z-index:1000;
	box-shadow: 0px 6px 20px 0px rgba(30,64,175,0.08);
	.tabs {
	// margin: 0 16px;
	display: flex;
	align-items: center;
	margin-bottom: 10px;
	.w-tabs {
		height: 32px;
		background: #f4f6f9;
		border-radius: 8px;
		// opacity: 0.6;
	}
	:deep(.w-tabs-nav-type-rounded .w-tabs-tab) {
		margin: 0 2px !important;
		&:hover{
			border-radius: 6px !important;
		}
	}
	.w-tabs-tab {
		width: 44px;
		height: 28px;
		margin-top: 2px;
		display: flex;
		justify-content: center;
		font-size: var(--font14);
		font-weight: 500;
		color: #646479;
	}
:deep(.w-tabs-tab-title){
	color: #646479;
}
	:deep(.w-tabs-tab-active) {
		background-color: #ffffff;
		// box-shadow: 0px 4px 10px 0px rgba(30, 64, 175, 0.1);
		border-radius: 6px;
		// color: #355eff;
		color: #181B49;
		height: 28px;
		.w-tabs-tab-title{
			color: #355eff;
		}
	}
}
.webAllInfo{
	color: #646479;
	font-size: var(--font14);
}
	.originContentBox-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		// margin-bottom: 16px;
		margin-bottom: 10px;
		.head-left {
			display: flex;
			align-items: center;
			.head-left-item {
				margin-right: 20px;
				// cursor: pointer;
				.item-name {
					font-size: 16px;
					color: #727298;
					.name{
						margin-right: 4px;
					}
					.activeNum {
						color: #355eff;
					}
				}
				.active {
					font-size: 16px;
					color: #181b49;
					font-family: MiSansMedium;
				}
			}
		}
		.head-right{
			.icon{
				cursor: pointer;
				&:hover{
					color: #355eff;
				}
			}
			.icon-box{
				width: 28px;
        height: 28px;
        background: #fff;
        border-radius: 8px;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			.active{
        background: rgba(53,94,255,.06);
			}
		}
	}
	.originContentBox-content {
		height: 230px;
		overflow-y: auto;
		.origin-list {
			height: 100%;
			.origin-list-box {
				margin-bottom: 12px;
				display: grid;
				grid-template-columns: repeat(3, 1fr);
				gap: 12px;
			}
			.origin-list-item {
				display: flex;
				height: 66px;
				border-radius: 8px;
				border: 1px solid #e4e8ee;
				padding: 12px;
				position: relative;
				cursor: pointer;
				.selected,
				.noselect {
					position: absolute;
					bottom: 0;
					right: 0;
				}
				.noselect {
					display: none;
				}
				.recommend{
					position: absolute;
					top: 0;
					right: 0;
					// width: 54px;
          height: 22px;
          background: linear-gradient( 270deg, rgba(255, 11, 0, .1) 0%, rgba(255, 155, 0, .1) 100%);
					border-radius:0 8px 0 8px;
					display:flex;
					align-items: center;
					padding:0 9px;
					font-size: var(--font12);
					color:#FF6200;
					.name{
						margin-left: 3px;
					}
				}
				.item-left {
					width: 36px;
					height: 36px;
					display: flex;
					align-items: center;
					justify-content: center;
					img {
						width: 24px;
						height: auto;
						max-height: 36px;
						object-fit: contain;
					}
				}
				.item-right {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					width: calc(100% - 40px);
					.item-right-name {
						font-size: var(--font16);
						color: #181b49;
						width: 120px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					.item-right-label {
						display: flex;
						align-items: center;
						img {
							width: 12px;
							height: 12px;
							margin-top: 2px;
						}
						.type {
							font-size: var(--font12);
							color: #181b49;
							margin: 0 4px;
							width:fit-content;
						}
						.line {
							width: 1px;
							height: 12px;
							background: #e4e8ee;
							margin-right: 4px;
						}
						.desc {
							// width: calc(100% - 50px);
							// max-width:110px;
							flex:1;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							font-size: var(--font12);
							color: #727298;
						}
					}
				}
				&:hover .noselect {
					display: block;
				}
			}
		}
		.knowledgeModelCard-list {
			height: 100%;

			.knowledgeModelCard-list-box {
				margin-bottom: 12px;
				display: grid;
				grid-template-columns: repeat(3, 1fr);
				gap: 12px;
			}
			&::-webkit-scrollbar {
				// display: none;
			}
			.data-item {
				display: flex;
				height: 66px;
				border-radius: 8px;
				border: 1px solid #e4e8ee;
				padding: 12px;
				position: relative;
				cursor: pointer;
				.selected,
				.noselect {
					position: absolute;
					bottom: 0;
					right: 0;
				}
				.noselect {
					display: none;
				}
				.item-icon {
					width: 36px;
					height: 36px;
					border-radius: 8px;
					display: flex;
					align-items: center;
					justify-content: center;
					.icon-content {
						width: 24px;
						height: 29px;
						display: flex;
						align-items: center;
						justify-content: center;
					}
				}
				.item-desc {
					width: 120px;
					margin-left: 12px;
					.desc-name {
						@include text;
						font-size: var(--font14);
						color: #181b49;
					}
					.desc-num {
						font-size: var(--font12);
						color: #9a99aa;
					}
				}
				.item-select {
					display: none;
					.w-checkbox-icon {
						width: 14px;
						height: 14px;
					}
				}
				.item-select-active {
					display: block;
				}
				&:hover .noselect {
					display: block;
				}
			}
		}
		.nodata-box {
			.nodata {
				margin: auto;
				margin-top: 40px;
				height: 100px;
				:deep(.w-empty-image) {
					margin: auto;
					width: 200px;
					height: 150px;
				}
			}
			.info-title {
				font-size: var(--font16);
				color: #181b49 !important;
				margin-bottom: 4px;
			}
			.info-message {
				font-size: var(--font14);
				color: #9a99aa;
				margin-bottom: 28px;
			}
			.w-btn {
				height: 36px;
				background: #355eff;
				border-radius: 8px;
				font-size: var(--font14);
				color: #ffffff;
			}
		}
	}
}
.isOriginSelect{
	height: 360px;
}
</style>
<style>
.originPop {
	/* left:450px !important; */
}
.originList {
	width: 500px;
	height: 300px;
	background-color: red;
}
.select-dropdown {
	width: 160px;
	height: 224px;
	background: #ffffff;
	box-shadow: 0px 6px 20px 0px rgba(30, 64, 175, 0.06) !important;
	border-radius: 8px !important;
	border: 1px solid #e4e8ee !important;
	overflow-y: auto;
	padding: 12px;
	.icon{
		cursor: pointer;
	}
	.w-popover-content {
		padding: 0;
	}
	.title {
		font-size: 14px;
		color: #181b49;
		font-family: MiSansMedium;
		margin-bottom: 8px;
	}
	.lists {
		display: flex;
		flex-wrap: wrap;
		.item {
			height: 28px;
			background: #f4f6f9;
			border-radius: 4px;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-right: 8px;
			margin-bottom: 8px;
			width: 60px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			cursor: pointer;
			border: 1px solid transparent;
			&:hover {
				background: rgba(53, 94, 255, 0.06);
			  border: 1px solid #355eff;
			  color: #355eff;
			}
			&:nth-child(2n) {
				margin-right: 0;
			}
		}
		.active {
			background: rgba(53, 94, 255, 0.06);
			border: 1px solid #355eff;
			color: #355eff;
		}
	}
}
</style>
